import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum ResourceManagementType {
  system = '1',
  custom = '2',
}

const nameConfig = {
  system: new Map([
    [Locale.ja, 'ProPlus管理'],
    [Locale.en, 'ProPlus Managed'],
  ]),
  custom: new Map([
    [Locale.ja, 'ユーザー管理'],
    [Locale.en, 'User Managed'],
  ]),
};

const toEnum = rawValueToEnum(ResourceManagementType, ResourceManagementType.system);
const toDisplay = enumToName(ResourceManagementType, nameConfig);
const toDisplayWithPrefix = enumToName(ResourceManagementType, nameConfig, { prefix: true });

export const resourceManagementType = {
  enum: ResourceManagementType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ResourceManagementType };
